import { NativeQSenseControlPlugin } from '@/plugins/NativeQSenseControl/definitions';
import { QSenseHubControlPlugin } from '@/plugins/QSenseHubControl';

import { ILedManager } from './interfaces/ILedManager';

function isNativeQSenseControlPlugin(
  plugin: NativeQSenseControlPlugin | QSenseHubControlPlugin,
): plugin is NativeQSenseControlPlugin {
  return (plugin as NativeQSenseControlPlugin).playAnimation !== undefined;
}

export class LedManager implements ILedManager {
  private plugin: NativeQSenseControlPlugin | QSenseHubControlPlugin;

  constructor(plugin: NativeQSenseControlPlugin | QSenseHubControlPlugin) {
    this.plugin = plugin;
  }

  async playAnimation(macAddress: string, red: number, green: number, blue: number, animation: 'fixed' | 'blink') {
    if (isNativeQSenseControlPlugin(this.plugin)) {
      return this.plugin.playAnimation({ macAddress, red, green, blue, animation: animation === 'blink' ? 0 : 1 });
    }
  }
}
